import { memo, PropsWithChildren, useMemo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'

import { PARTNER_CONTAINER_HEADER_HEIGHT } from '../../configs'
import { PartnerFormTitle } from '../partnerFormTitle/PartnerFormTitle'

import { IPartnerFormContainerProps } from './models'

import styles from './PartnerFormContainer.module.scss'

export const PartnerFormContainer = memo<PropsWithChildren<IPartnerFormContainerProps>>(
  ({ partner, title, children }) => {
    const preparedTitle = useMemo(() => {
      if (typeof title === 'string') {
        return <Translation text={title} />
      }
      return title
    }, [title])

    return (
      <div className={styles.container}>
        <header className={styles.header} style={{ height: PARTNER_CONTAINER_HEADER_HEIGHT }}>
          <PartnerFormTitle title={preparedTitle} partner={partner} />
        </header>
        <div className={styles.content}>{children}</div>
      </div>
    )
  }
)
